<template>
  <div>
    <div class="col-md-5">
      <div class="vue3-component" id="BookingBasicInfo"></div>

      <upcoming-appointments
        :can-see-customer="canSeeCustomer"
        :logged-user-role="allObject.loggedUserRole"
        :customer="allObject.customer"
        :booking="allObject.event"
        :view-page="true"
      >
      </upcoming-appointments>

      <customers
        :can-see-customer="canSeeCustomer"
        :logged-user-role="allObject.loggedUserRole"
        item-type="booking"
        :event="allObject.event"
        :customer-id="allObject.booking.customer_id"
        :item-id="allObject.booking.booking_id"
        :estimate-id="(allObject.estimateParams || {}).id"
        :has-estimate="allObject.hasEstimate"
        :invoice-id="(allObject.bookingInvoices[0] || {}).id"
        :from-view-page="true"
        :customer-signed="null"
        :customer-signature-id="allObject.customerSignaturesId"
        :show-address="allObject.show_address"
        :signature-link="allObject.signature_link"
        :all-labels="allObject.allLabels"
        :booking-customers="allObject.booking_customers"
        :can-add-customer="allObject.canAddCustomer"
        :can-edit-customer="allObject.canEditCustomer"
        :all-object="allObject"
      >
      </customers>


      <div class="ibox float-e-margins">
        <booking-view-scheduled-visits
          v-if="allObject.status?.has_date && false"
          :booking-id="allObject.booking.booking_id"
          :is-virtual="allObject.is_virtual ? 'true' : 'false'"
          :timezone="
            allObject.is_virtual
              ? get_timezone_identifier(allObject.loggedUser.timezone)
              : null
          "
        >
        </booking-view-scheduled-visits>
        <repeat-bookings-view
          v-if="allObject.loggedUserRole != 'customer'"
          :item-id="allObject.booking.booking_id"
          :view-page="true"
        ></repeat-bookings-view>

        <div
          class="ibox float-e-margins fadeInRight"
          id="booking-properties"
          v-if="
            allObject?.propartyBookingCustom &&
            allObject.propartyBookingCustom.length > 0
          "
        >
          <div class="ibox-title">
            <booking-properties
              :all-object="allObject"
              :company ="allObject.company"
              :customer-id="allObject.booking.customer_id"
              :can-see-customer="canSeeCustomer"
              :logged-user-role="allObject.loggedUserRole"
              :country-code="allObject.country.country_code"
              :country-key="allObject.country.country_key"
              :date-format="allObject.dateFormat"
              :base64-encoded-properties="allObject.propartyBookingCustom"
              property-type="booking"
              :properties="allObject.propartyBookingCustom"
              item-type="customerprofile"
              :booking-id="allObject.booking.booking_id"
              :invoice-id="(allObject.bookingInvoices[0] || {}).id"
              :booking-info="allObject.booking"
              from-booking="true"
              view-booking="true"
            >
            </booking-properties>
          </div>
        </div>

        <div class="ibox float-e-margins">
          <div class="ibox-content" id="booking_field_worker_profile">
            <table class="table">
              <tbody>
                <tr>
                  <td style="padding: 0">
                    <location-box-inside-view-page
                      v-show="
                        allObject.line_address_with_lat_lon &&
                        allObject.line_address_with_lat_lon.length > 0 &&
                        allObject.loggedUserRole != 'customer' &&
                        allObject.show_address &&
                        !isVirtualData
                      "
                      :all-locations-inside-item="
                        allObject.line_address_with_lat_lon
                      "
                      :company-address-label="allObject.address_label"
                    >
                    </location-box-inside-view-page>
                  </td>
                </tr>
                <online-virtual-booking
                  v-show="isVirtualData"
                  :is-Virtual="isVirtualData"
                  :booking-object="allObject.booking"
                >
                </online-virtual-booking>
              </tbody>
            </table>
          </div>
        </div>

        <payment-and-fieldworker-earning
          :can-see-customer="canSeeCustomer"
          :logged-user="allObject.loggedUser"
          :currency="allObject.currency"
          :booking-invoices="allObject?.bookingInvoices"
          :booking-payment-summary="allObject.bookingPaymentSummary"
          :booking-id="allObject.booking.booking_id"
          item-type="booking"
          :item-id="allObject.booking.booking_id"
          merged-invoice-id="0"
          :has-recurring="
            allObject.repeatedBookings && allObject.repeatedBookings.length > 0
          "
          :show-fieldworker-payment="showFieldworkerPayment"
          :booking-nums="allObject.booking.booking_num"
          :company-has-default-payment-gateway="
            allObject.companyHasDefaultPaymentGateway
          "
          :show-view-invoice-popup="allObject.show_invoice_popup"
        >
        </payment-and-fieldworker-earning>
        <div></div>

        <div
          v-for="(contractor, index) in allObject.availableContractorsByState"
          :key="index"
        >
          <template v-if="shouldDisplayContractor(contractor)">
            <div
              :id="`contractor_${allObject.booking.booking_id}_${contractor.user_id}`"
              :class="`AvailablecontractorDiv_${allObject.booking.booking_id}`"
              :value="contractor.user_id"
            ></div>
            <div
              :id="`contractorLatLon_${allObject.booking.booking_id}_${contractor.user_id}`"
              :value="
                contractor.contractorLatLonAddress
                  ? JSON.stringify({
                      lat: contractor.contractorLatLonAddress.lat,
                      lon: contractor.contractorLatLonAddress.lon,
                    })
                  : ''
              "
            ></div>
          </template>
        </div>
        <div
          v-for="(subContractor, index) in allObject.subworkerDistances"
          :key="index"
        >
          <template v-if="shouldDisplayContractor(subContractor)">
            <div
              :id="`contractor_${allObject.booking.booking_id}_${subContractor.user_id}`"
              :class="`AvailablecontractorDiv_${allObject.booking.booking_id}`"
              :value="subContractor.user_id"
            ></div>
            <div
              :id="`contractorLatLon_${allObject.booking.booking_id}_${subContractor.user_id}`"
              :value="
                subContractor.contractorLatLonAddress
                  ? JSON.stringify({
                      lat: subContractor.contractorLatLonAddress.lat,
                      lon: subContractor.contractorLatLonAddress.lon,
                    })
                  : ''
              "
            ></div>
          </template>
        </div>

        <available-fieldworkers
          item-type="booking"
          :item-id="allObject.booking.booking_id"
          :label-workers-name="allObject.workersNameSingular"
          :show-address="allObject.show_address"
          :line-address="allObject.line_address_with_lat_lon"
          :booking-address="allObject.bookingAddressArr"
          :is-address="allObject.is_address ? allObject.is_address : 0"
          :all-labels="allObject.allLabels"
        ></available-fieldworkers>
      </div>
    </div>

    <div class="col-md-7">
      <div class="ibox">
        <div
          class="container-width container add-booking-container-width form-horizontal service-container mobile-m-top-30 p-bottom-14"
          id="booking-service-container"
          style="background-color: #ffffff; display: none; width: 100%"
        >
          <input
            type="hidden"
            id="customer_id"
            name="customer_id"
            :value="(this.allObject.booking || {}).customer_id"
          />
          <input
            type="hidden"
            id="bookingStatus"
            :value="(this.allObject.booking || {}).status_id"
          />
          <input type="hidden" id="view_booking" value="1" />

          <booking-form :all-object="allObject" :view-page="true">
          </booking-form>

          <div class="row">
            <div class="ibox-content border-none add_border_to_main_section">
              <gallery
                v-if="allObject.bookingStatusName !== 'GIFT CARD'"
                :can-see-customer="canSeeCustomer"
                :logged-user-role="allObject.loggedUserRole"
                :item-id="allObject.booking.booking_id"
                item-type="booking"
                :photos-link="allObject.photosLink"
                :photos-api="allObject.photosApi"
                :add-photos-link="allObject.addPhotosLink"
                :restore-image-link="allObject.restoreImageLink"
                :singular-worker-name="allObject.singularWorkerName"
                :from-booking="true"
                :invoice-id="allObject?.bookingInvoice?.id"
                :customer-id="allObject.booking.customer_id"
                :type="allObject.type"
                :images="allObject.images"
                :have-images="allObject.haveImages"
                :add-photos-and-attachments-params="
                  allObject.addPhotosAndAttachmentsParams
                "
              ></gallery>
            </div>
          </div>

          <Booking-rates
            v-if="
              allObject.loggedUser.role_name !== 'customer' &&
              allObject.bookingStatusName !== 'GIFT CARD' &&
              allObject.bookingStatusName === 'COMPLETED' &&
              (allObject.any_contractor_has_rate ||
                (allObject.timeNow > allObject.lastBookingDay &&
                  allObject.bookingPaymentSummary['balance_due'] == 0))
            "
            :logged-user="allObject.loggedUser"
            :booking-id="allObject.booking.booking_id"
          ></Booking-rates>

          <!--                  <tabs-->
          <!--                      v-if="allObject.loggedUser.role_name !== 'customer'"-->
          <!--                      :item-type="allObject.booking.status_id ===3 ?'estimate':'booking'"-->
          <!--                      :item-id="allObject.booking.status_id ===3 ? allObject.bookingEstimate.id:allObject.booking.booking_id"-->
          <!--                      :booking-id="allObject.booking.booking_id"-->
          <!--                      :credentials='allObject.tabsCredentials'-->
          <!--                      :customer-id='allObject.booking.customer_id'-->
          <!--                  >-->
          <!--                  </tabs>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/events/event-bus";
import Customers from "../../Customer/components/Customers.vue";
import AddCustomersPopup from "../../Customer/components/addCustomersPopup.vue";

export default {
  name: "OverviewTab",
  components: { AddCustomersPopup, Customers },
  props: {
    allObject: {
      type: Object,
    },
  },
  computed: {
    showFieldworkerPayment() {
      const giftCardStatus = this.allObject.bookingStatus.find(
        (status) => status.name === "GIFT CARD"
      );

      if (
        giftCardStatus &&
        this.allObject.booking.status_id !== giftCardStatus.booking_status_id &&
        ("customer" == this.allObject.loggedUserRole ||
          (this.allObject.loggedUserRole == "contractor" &&
            (!("payment_fieldworker_flag" in this.allObject.company) ||
              this.allObject.company.payment_fieldworker_flag == 0)))
      ) {
        return 0;
      } else {
        return 1;
      }
    },
    canSeeCustomer(){
      return (
        this.allObject.company.show_customer_number_in_app &&
        this.allObject.loggedUserRole == 'contractor'
      )
    },
  },

  data() {
    return {
      isVirtualData: this.allObject.is_virtual,
    };
  },
  methods: {
    shouldDisplayContractor(contractor) {
      return !(
        this.allObject.loggedUserRole == 'contractor' &&
        this.allObject.loggedUser.user_id != contractor.user_id
      );
    },
  },
  mounted() {
    EventBus.$on("bookingVirtual", (bookingAddresses) => {
      this.isVirtualData = true;
    });
    EventBus.$on("bookingAddressesChanged", (bookingAddresses) => {
      this.allObject.line_address_with_lat_lon = bookingAddresses;
      this.isVirtualData = false;
    });
  },
};
</script>

<style scoped>
.we_can_delete_it_later {
  display: none !important;
}
.add-booking-container-width .fieldworker-box .select2-selection__rendered {
  justify-content: flex-start !important;
  display: flex !important;
}

.sub-fieldworker-box .select2-selection__rendered {
  width: 100% !important;
}

.save_booking_btn,
#editButton {
  margin-bottom: 0px !important;
}
.add_border_to_main_section {
  border-top: #f3f3f4 19px solid;
}

@media (max-width: 768px) {
  .add-booking-container-width .fieldworker-box .select2-selection__rendered {
    width: 100% !important;
  }
}


</style>
